import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {FileManagerService} from '../../main/file-manager/file-manager.service';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './upload-file-dialog.component.html',
    styleUrls: ['./upload-file-dialog.component.scss']
})
export class UploadFileDialogComponent implements OnInit{
    fileList: string[];
    fileDirectory: string;
    form: FormGroup;
    filesToUpload: File[] = [];

    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<UploadFileDialogComponent>,
        private _fileManagerService: FileManagerService,
        @Inject(MAT_DIALOG_DATA) public data: UploadFileDialogModel) {
        // Update view with given values
        this.fileList = data.fileList;
        this.fileDirectory = data.fileDirectory;
        this._fileManagerService.currentPath = data.fileDirectory;
    }
    ngOnInit(): void
    {
        this.form = this.fb.group({
            fileList: [this.fileList, []],
            fileDirectory: [this.fileDirectory],
            filesToUpload: [this.filesToUpload, []]
        });
    }

    processUploads(filePath?: string): void {
        if (!filePath)
        {
            filePath = this._fileManagerService.currentPath;
        }
        const file = this.filesToUpload.pop();
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (): void => {
            const base64file = (reader.result as string).split(',')[1];
            let fullFilePath;
            if (filePath === '/')
            {
                fullFilePath = '/' + file.name;
            }
            else {
                fullFilePath = filePath + '/' + file.name;
            }
            console.log('uploading:' + filePath + file.name);
            this._fileManagerService.uploadFile(fullFilePath, base64file, true ).then()
                .finally(() => {
                        if (this.filesToUpload.length > 0) {
                            console.log('run again');
                            this.processUploads();
                        }
                        else {
                            this.dialogRef.close();
                        }
                    }
                );
        };
        reader.onerror = (error) => {
            console.log('Error: ', error);
        };
    }

    onDismiss(): void {
        // Close the dialog, return false
        this.dialogRef.close();
    }

    handleFileInput(event: any): void {
        console.log(event);
        for (const file of event.target.files) {
            this.filesToUpload.push(file);
        }
    }
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class UploadFileDialogModel {

    constructor(
        public fileList: string[],
        public fileDirectory
    )
    {

    }
}
